/**
 * @description Axios HTTP Handler Utility
 * @author Fahid Mohammad
 */
// TODO: Need to handle all types of request in case of post
//       Need to clear unwanted consolses once the final development is over
//       Code refactor is needed, need to find a better solution to handle request and response with a rejection
import axios from 'axios'
import store from '../store'
import config from '../../config/endpoints.js'
import router from "../router/index"

let http = axios.create({
  baseURL: config.oh_url,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    'platform': 'hms'
  },
  withCredentials: false
})

http.interceptors.request.use((config) => {
    const token = store.getters['auth/getToken'] || null
    if(token){
        config.headers['Authorization'] = token;
    }
    return config;
}, (error) => {
    return Promise.reject(error)
})
http.interceptors.response.use(res => {
    let data = res.data
    if (data && data.status === 2001) {
        store.dispatch("auth/LOGOUT").then(() => {
            router.push("/login");
        });
    } else {
        return data
    }
}, error => {
    if (error.response) {
        console.error('Response: ', error.response.data)
        console.error('Status: ', error.response.status)
        console.error('Headers: ', error.response.headers)
    } else {
        console.error('Error: ', error.message)
    }
    console.error('Config:', error.config)
    return Promise.reject(error)
})

export default http



// WEBPACK FOOTER //
// ./src/util/axios.js